import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from '@strata-monorepo/shared-ui/utils/cn'

export function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>): React.JSX.Element {
  const spacingStyles = 'flex items-center gap-2 leading-none'
  const fontStyles = 'text-sm font-medium select-none'
  const disabledStyles =
    'peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50'

  return (
    <LabelPrimitive.Root
      data-slot='label'
      className={cn(spacingStyles, fontStyles, disabledStyles, className)}
      {...props}
    />
  )
}
